<div class="user-property-heading-row">
  <div>
    <h3>Manage Pricing</h3>
    <div class="address-block-with-icon">
      <div class="address-block-icon">
        <mat-icon class="location-color">location_on</mat-icon>
      </div>
      <div class="address-block-address">
        {{ property?.address?.street }}<br/>{{ property?.address?.city }}, {{ property?.address?.state }}
      </div>
    </div>
  </div>
  <div>
    <button mat-flat-button class="metallic-text-btn-blue" (click)="add()">
      <mat-icon matPrefix>add</mat-icon>
      Add
    </button>
  </div>
</div>

@if(dataSource.data) {

    <div class="user-property-list-table-container mat-elevation-z8">
        
        <mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
                <mat-cell *matCellDef="let pr"> {{ pr.name }} </mat-cell>
            </ng-container>
            
            <ng-container matColumnDef="priority">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
                <mat-cell *matCellDef="let pav"> {{ pav.priority ?? '' }} </mat-cell>
            </ng-container>
            
            <ng-container matColumnDef="startDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Start </mat-header-cell>
                <mat-cell *matCellDef="let pav"> {{ pav.startDate | date: 'MMMM dd, yyyy' }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="endDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header> End </mat-header-cell>
                <mat-cell *matCellDef="let pav"> {{ pav.endDate | date: 'MMMM dd, yyyy' }} </mat-cell>
            </ng-container>
            
            <ng-container matColumnDef="priceCents">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Cost </mat-header-cell>
                <mat-cell *matCellDef="let pav"> {{ pav.priceCents / 100 | currency }} </mat-cell>
            </ng-container>
    
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
            <mat-cell *matCellDef="let pav">
    
                <button mat-icon-button color="primary" (click)="editRule(pav.id)" matTooltip="Manage Rule">
                  <mat-icon>edit_calendar</mat-icon>
                </button>
    
                <button 
                  mat-icon-button 
                  color="primary" 
                  (click)="removeRule(pav.id)" 
                  [disabled]="pav.name === 'Default Base Rate'"
                  [matTooltip]="pav.name === 'Default Base Rate' 
                    ? 'Default Base Rate cannot be removed' 
                    : 'Remove'">
                  <mat-icon>delete</mat-icon>
                </button>
    
            </mat-cell>
        </ng-container>
    
          <mat-header-row *matHeaderRowDef="['name', 'priority', 'startDate', 'endDate', 'priceCents', 'actions']"></mat-header-row>
          
          <mat-row *matRowDef="let row; columns: ['name', 'priority', 'startDate', 'endDate', 'priceCents', 'actions'];"></mat-row>
        </mat-table>
    
      </div>
}
